import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { URL_GLOBAL } from 'src/environments/environment';
import { AuthService } from '../vos/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ProfissionalService {

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  getProfissionais(): Observable<any[]> {
    return this.http.get<any[]>(`${URL_GLOBAL}/web/recursosHumanos/profissionais`, { headers: this.authService.userToken() });
  }
  getProfissionaisAcessos(url: any, params:any): Observable<any[]> {
    return this.http.get<any[]>(`${url ? url + '&paginate=1' : `${URL_GLOBAL}/web/recursosHumanos/profissionaisAcessos?paginate=1`}&nome=${params.nome ? params.nome : '' }`, { headers: this.authService.userToken() });
  }
  buscaProfissionaisInternosPagamentos(): Observable<any[]> {
    return this.http.get<any[]>(`${URL_GLOBAL}/web/buscaProfissionaisInternosPagamento`, { headers: this.authService.userToken() });
  }

  find(id: any): Observable<any> {
    return this.http.get(`${URL_GLOBAL}/web/recursosHumanos/profissionais/${id}`, { headers: this.authService.userToken() });
  }

  destroy(id: any): Observable<any> {
    return this.http.delete<any>(`${URL_GLOBAL}/web/recursosHumanos/profissionais/${id}`, { headers: this.authService.userToken() });
  }

  save(data: any): Observable<any> {
    // const formData: FormData = new FormData();
    // formData.append('data', JSON.stringify(data));
    // formData.append('documentos[]', JSON.stringify(data));
    // let files: any = []
    // for (var i = 0; i < data.documentos.length; i++) {
    //   // data.documentos[i].anexo.file.descricao = data.documentos[i].descricao;
    //   formData.append('documentos[]', JSON.stringify(data.documentos[i]));
    // }
    return this.http.post<any>(`${URL_GLOBAL}/web/recursosHumanos/profissionais/novoProfissional`, data, { headers: this.authService.userToken() });
  }

  update(id: any, data: any): Observable<any> {
    return this.http.put<any>(`${`${URL_GLOBAL}/web/recursosHumanos/profissionais`}/${id}`, data, { headers: this.authService.userToken() });
  }
  meuperfil(): Observable<any> {
    return this.http.get<any>(`${URL_GLOBAL}/web/meu-perfil`, { headers: this.authService.userToken() });
  }
  atualizarFotoPerfil(token): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': token["token_type"] + " " + token.access_token
    });
    return this.http.put<any>(`${URL_GLOBAL}/web/meu-perfil/atualizarFotoPerfil`, token.user, { headers });
  }
  unidadesFederativas(): Observable<any> {

    return this.http.get<any[]>(`${URL_GLOBAL}/web/uf/list`, { headers: this.authService.userToken() });
  }
}
